import React from 'react';
import { ArrowRightIcon, FileTextIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { achievements } from '../../data/record';
const [featured, ...supporting] = achievements;
export function TrackRecordPreview() {
  return <section aria-labelledby="record-heading" className="bg-white py-16 sm:py-20 lg:py-28" data-id="element-373" data-mp="3ix9v853w2ijs">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-374" data-mp="1p4xmv0c2vzf">
        <SectionHeading eyebrow="Track record" title="Judge the plan by the record" intro="Every claim on this site is tied to a public document. Here are three you can check today." action={<Button variant="secondary" data-id="element-376" data-mp="6hy01c8bxs8c">
              Explore the leadership record
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-377" data-mp="khz5l4zjhnu5" />
            </Button>} data-id="element-375" data-mp="3sxslbhm1qva5" />

        <div className="mt-12 grid gap-6 lg:grid-cols-12" data-id="element-378" data-mp="fjxlcgqdnih3">
          <Reveal className="lg:col-span-7" data-id="element-379" data-mp="1t4pk361kbgvc">
            <article className="flex h-full flex-col rounded-media border border-sand-200 bg-sand-50 p-7 lg:p-9" data-id="element-380" data-mp="1t5qzfmpm2piv">
              <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-green-700" data-id="element-381" data-mp="1y4u1cyaaofmm">
                {featured.period}
              </p>
              <h3 className="mt-2 font-display text-[26px] leading-tight text-ink sm:text-[30px]" data-id="element-382" data-mp="274qk6ja06k9r">
                {featured.role}
              </h3>

              <dl className="mt-7 space-y-5" data-id="element-383" data-mp="2c0xrogi1s3tt">
                {[['The challenge', featured.challenge], ['The action', featured.action]].map(([label, value]) => <div key={label} className="border-l-2 border-sand-300 pl-4" data-id="element-384" data-mp="2qresbxmuyppn">
                    <dt className="text-[12px] font-bold uppercase tracking-[0.1em] text-slate-500" data-id="element-385" data-mp="2qthgsd8d4as9">
                      {label}
                    </dt>
                    <dd className="mt-1.5 text-[15px] leading-relaxed text-slate-700" data-id="element-386" data-mp="2zt4lp90avyq2">{value}</dd>
                  </div>)}
                <div className="border-l-2 border-green-600 pl-4" data-id="element-387" data-mp="znqvtqqjfc0m">
                  <dt className="text-[12px] font-bold uppercase tracking-[0.1em] text-green-700" data-id="element-388" data-mp="vq2yyi5ab963">
                    The outcome
                  </dt>
                  <dd className="mt-1.5 font-display text-[19px] leading-snug text-ink" data-id="element-389" data-mp="14pg7n8ll3tpr">
                    {featured.outcome}
                  </dd>
                </div>
              </dl>

              <a href="/track-record" className="mt-auto flex items-center gap-2 pt-8 text-[13px] text-slate-500 transition-colors duration-150 ease-emphasis hover:text-green-700" data-id="element-390" data-mp="1ef9lyhd42mxp">
                <FileTextIcon aria-hidden className="h-4 w-4" data-id="element-391" data-mp="1ngqyxqv828i6" />
                Source: {featured.source}
              </a>
            </article>
          </Reveal>

          <div className="grid gap-6 lg:col-span-5" data-id="element-392" data-mp="3p72fj9r5xxek">
            {supporting.map((item, index) => <Reveal key={item.role} delay={0.05 * (index + 1)} data-id="element-393" data-mp="24p0cdhx37ssa" data-mpi={index}>
                <article className="flex h-full flex-col rounded-card border border-sand-200 bg-white p-6 shadow-card" data-id="element-394" data-mp="24ps3ogjnj4cr">
                  <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-green-700" data-id="element-395" data-mp="29pxszq2g8ero">
                    {item.period}
                  </p>
                  <h3 className="mt-1.5 font-display text-[20px] leading-snug text-ink" data-id="element-396" data-mp="1zwyzpuw0c01q">
                    {item.role}
                  </h3>
                  <p className="mt-3 text-[14px] leading-relaxed text-slate-600" data-id="element-397" data-mp="1m0v7g74p21rw">{item.action}</p>
                  <p className="mt-4 border-t border-sand-200 pt-4 font-display text-[16px] leading-snug text-ink" data-id="element-398" data-mp="1qv91a53pk0ug">
                    {item.outcome}
                  </p>
                  <p className="mt-auto flex items-center gap-2 pt-5 text-[12px] text-slate-500" data-id="element-399" data-mp="1gzphgh2f4sm2">
                    <FileTextIcon aria-hidden className="h-3.5 w-3.5" data-id="element-400" data-mp="37cmy48sg77hr" />
                    {item.source}
                  </p>
                </article>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}